export function on(parent, event, selector, handler) {
  const listener = (e) => {
    const match = e.target.closest(selector);
    if (!match || !parent.contains(match)) {
      return;
    }
    handler(e);
  };

  parent.addEventListener(event, listener);

  return () => {
    parent.removeEventListener(event, listener);
  };
}
